import React from 'react';
import { NavLink } from 'react-router-dom'; // Import NavLink from React Router

function Navbar() {
  return (
    <nav className="nav-bar">
      <ul>
        <li>
          <NavLink
            exact="true"
            to="/"
            className={({ isActive }) => (isActive ? 'active-nav' : '')}
          >
            Join Waitlist
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/about"
            className={({ isActive }) => (isActive ? 'active-nav' : '')}
          >
            About Nova
          </NavLink>
        </li>
      </ul>
    </nav>
  );
}

export default Navbar;
